import { data } from "jquery";
import { deleteRequest, getRequest, postRequest, putRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken, getToken } from "../../utils/tokenUtils";
import { json } from "zod";



export const GetPartnerReport = async (payload) => {
    try {
        const token = getAuthToken();
        const res = await getRequest({
            url: API_URLS.BASE_URL + `admin/get-partner`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            params: payload,
        });

        console.log("Partner Report Response:", res);
        return res;
    } catch (error) {
        console.error("Service Error:", error);
        return error?.response || error;
    }
};



export const UpdatePartnerPNT = async (payload , partner_id) => {
    const token = getAuthToken();

    return await putRequest({
        url: API_URLS.BASE_URL + `update-lead-partner/${partner_id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: payload,
    });
};

export const UpdatePartnerENT = async (payload ,  partner_id) => {
    const token = getAuthToken();

    return await putRequest({
        url: API_URLS.BASE_URL + `update-partner/${partner_id}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: payload,
    });
};